import { ModuleRegisterContext, ModuleRegisterFn } from "@/module-register"

const registerCareNavModule: ModuleRegisterFn = (_context: ModuleRegisterContext) => {
  console.log("Care Nav module registered!")
}

export default registerCareNavModule
